export const defaultTheme = {
  name: 'defaultTheme',
  fonts: {
    primary: '"Source Sans Pro", sans-serif',
    bold: '"Source Sans Pro", semi-bold',
    lucida: 'LucidaGrande',
  },
  fontSizes: {
    h1: '24px',
    h2: '16px',
    p: '15px',
  },
  palette: {
    primary: ['#177ac2', '#1a8bde', '#104587', '#8dc5ef', '#1d92ea', '#3b9be2', '#1466b4', '#0b3870'],
    secondary: ['#ecbb01', '#ffca00', '#b79100', '#ffe57f'],
    danger: ['#d63c32'],
    alert: ['#1a8bde'],
    success: ['#0ed198'],
    grayscale: [
      '#3f4751',
      '#6a6b71',
      '#b9c0c9',
      '#9198a0',
      '#e3e6ea',
      '#ffffff',
      '#969fac',
    ],
    shadow: ['#250f8a', '#b0c0ed'],
  },
  notification: {
    success: [
      '#12be8c',
      'linear-gradient(93deg, rgba(14, 209, 152, 0.25), rgba(14, 209, 152, 0.2))',
    ],
    fail: [
      '#d63c32',
      'linear-gradient(93deg, rgba(209, 14, 14, 0.25), rgba(209, 14, 14, 0.2))',
    ],
    info: [
      '#1d92ea',
      'linear-gradient(93deg, rgba(121, 197, 255, 0.25), rgba(34, 159, 255, 0.2))',
    ],
  },
  flasks: {
    one: [
      '#1d93eb',
      'linear-gradient(to bottom, #64bcff, #147cc7)',
      'linear-gradient(168deg, #79c5ff, #229fff 44%, #0e6dae)',
    ],
    two: [
      '#6c47d3',
      'linear-gradient(to bottom, #9b67f2, #6a45d1)',
      'radial-gradient(circle at -8% -35%, #9b42ff, #9b71ee 50%, #4625bd)',
    ],
    three: [
      '#bc5086',
      'linear-gradient(to bottom, #d970a5, #bc5086)',
      'radial-gradient(circle at -8% -35%, #fa6db4, #d970a5 50%, #96265e)',
    ],
    four: [
      '#12579d',
      'linear-gradient(to bottom, #1a8bde, #12579d)',
      'radial-gradient(circle at -8% -35%, #afdcff, #1a8bde 50%, #104587)',
    ],
    five: [
      '#079168',
      'linear-gradient(to bottom, #10b282, #079168)',
      'radial-gradient(circle at -3% -30%, #b8e5dc, #10b282 56%, #04825d)',
    ],
    six: [
      '#104587',
      'linear-gradient(to bottom, #1461b1, #104587)',
      'radial-gradient(circle at 30% -3%, #3096dd, #1461b1 56%, #104587)',
    ],
    seven: [
      '#bc5086',
      'linear-gradient(to bottom, #d970a5, #bc5086)',
      'radial-gradient(circle at -8% -35%, #fa6db4, #d970a5 50%, #96265e)',
    ],
    eight: [
      '#d4a801',
      'linear-gradient(to bottom, #f2cf4d, #d4a801)',
      'radial-gradient(circle at -8% -35%, #f4d667, #f2cf4d 50%, #ecbb01)',
    ],
    nine: [
      '#ef933a',
      'linear-gradient(to bottom, #f0b330, #ef933a)',
      'radial-gradient(circle at 30% 0, #f0b330, #f49941 53%, #ef933a)',
    ],
  },
  limits: {
    self: '#1a8bde',
    vip: '#6c46d2',
    total: '#aa3d74',
  },
};
